import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-form',
    templateUrl: './formly-form.component.html',
    styleUrl: './formly-form.component.scss',
    imports: [FormlyModule]
})
export class FormlyFormComponent extends FieldType<FieldTypeConfig> {
}
